import React from 'react';

function ProjectTwo() {
    return (
        <div>
            <h1>Kur Dva</h1>
        </div>
    )
}

export default ProjectTwo;
